export default __webpack_public_path__ + "static/media/CNo.62-1.950f977b.jpg";